import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";
import { MST2010_R01Dto } from "./Dto_MST2010_R01";
import { MST2010_R01Filter } from "./Store_MST2010_R01";

const baseUrl = `${config.apiUrl}/MST2010_R01`;

export const getMST2010_R01List = async ( option:string, params: Partial<MST2010_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/${option}`;

	const requestParams = {
		areaCd:     params?.areaCd,
		searchText: params?.customCd,
		customType: params?.customType,
	}

	return await getData<ResponseDto<MST2010_R01Dto[]>>(url, {
		params: {
			...requestParams,
			listLength
		}
	});
}

export const getMST2010_R01AllCount = async (params: Partial<MST2010_R01Filter>) => {
    const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, {
        params: {
            areaCd:     params?.areaCd,
            searchText: params?.customCd,
            customType: params?.customType,
        }
    });
}

export const getMST2010_R01One = async (customCd: string) => {
	const url = `${baseUrl}/one/${customCd}`;

	return await getData<ResponseDto<MST2010_R01Dto>>(url);
}

export const createMST2010_R01 = async (data: MST2010_R01Dto) => {

	return await postData<MST2010_R01Dto, ResponseDto<MST2010_R01Dto[]>>(baseUrl, data);
}

export const patchMST2010_R01 = async (data: MST2010_R01Dto) => {

	return await patchData<MST2010_R01Dto, ResponseDto<MST2010_R01Dto[]>>(baseUrl, data);
}

export const deleteMST2010_R01 = async (customCd: string) => {
	const url = `${baseUrl}/${customCd}`;

	return await deleteData<ResponseDto<any>>(url);
}

export const downloadExcel_MST2010_R01 = async ( option:string, params: Partial<MST2010_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`;

	const requestParams = {
		areaCd:     params?.areaCd,
		searchText: params?.customCd,
		customType: params?.customType,
	}

	return await getData<ResponseDto<string>>(url, {
		params: {
			...requestParams,
			listLength
		}
	});
}